<template>
  <div class="user-profile">
    <div class="user-profile__content">
      <svg-icon name="user" class="user-profile__icon" />
      <span class="user-profile__name">Жеке кабинет</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import SvgIcon from "@/components/SvgIcon.vue";

export default defineComponent({
  components: { SvgIcon },
});
</script>

<style scoped lang="scss">
.user-profile {
  @apply p-[12px] bg-[#058242] rounded-2xl flex items-center cursor-pointer;

  &__content {
    @apply flex items-center gap-2;
  }

  &__icon {
    @apply w-6 h-6 text-white;
  }

  &__name {
    @apply hidden sm:block text-white text-[16px] leading-[21px];
  }
}
</style>
